import { ImageData, ImageContent } from "src/app/core/models/base-responses.model";

export class AlphaTechImageToUpload {
  // TODO: introduce enum for it: new image, other image, drawable
  imageData: ImageData = new ImageData();
  newImageSource: any; // TODO: use here the imageSource type

  constructor() { }
}
